









































































































































































































import Workspaces from './Services/Workspaces.vue';

export default {
	name: 'Teams',
	components: {
		Workspaces,
	},
	data() {
		const validateName: Function = (rule, value, callback) => {
			for (const el of this.drawerBehavior.indexOf('role') !== -1 ? this.roles : this.departments)
				if (el.name === value && this.form.id !== el.id) return callback(new Error('error'));
			return callback();
		};
		return {
			departmentDrawer: false,
			loading: false,
			form: {
				id: '',
				name: '',
				description: '',
			},
			formLabelWidth: '120px',
			inputVisible: false,
			inputValue: '',
			rolesDrawer: false,
			currentSelection: {},
			defaultProps: {
				children: 'apps',
				label: 'title',
			},
			drawerNewDepartment: false,
			selectedDepartment: null,
			drawerBehavior: 'new-department',
			rules: {
				name: [
					{ required: true, message: this.$t('teams.validation.nameRequired'), trigger: ['blur', 'change'] },
					{ validator: validateName, message: this.$t('teams.validation.nameTaken'), trigger: 'blur' },
				],
				description: [
					{ required: true, message: this.$t('teams.validation.descriptionRequired'), trigger: ['blur', 'change'] },
				],
			},
		};
	},
	computed: {
		departments(): object[] {
			return this.$store.state.departments;
		},
		roles(): object[] {
			return this.selectedDepartment ? this.selectedDepartment.roles : [];
		},
		workspaces(): object[] {
			return this.$store.state.workspaces;
		},
		drawerData(): object[] {
			const workspace = this.workspaces[this.currentSelection.id];
			return workspace
				? workspace
						.filter(el => el.type !== 'config')
						.sort((a, b) => (a.type === 'group' ? -1 : b.type === 'group' ? 1 : 0))
				: [];
		},
		users(): object[] {
			const users = this.$store.state.users || [];
			const emailInvites = this.$store.state.organization.emailInvitations || [];
			return [...users, ...emailInvites];
		},
		organizationPath(): string {
			return this.$store.getters.path;
		},
	},
	methods: {
		async validateForm(): Promise<boolean> {
			try {
				return await this.$refs.departmentForm.validate();
			} catch (error) {
				return false;
			}
		},
		drawerTitle(): string {
			switch (this.drawerBehavior) {
				case 'new-department':
					return this.$t('teams.newTeam');
					break;
				case 'edit-department':
					return this.$t('teams.editTeam');
					break;
				case 'new-role':
					return this.$t('teams.newWorkspace');
					break;
				case 'edit-role':
					return this.$t('teams.editWorkspaceTitle');
					break;
				default:
					return this.$t('teams.newFallback');
					break;
			}
		},
		async drawerClickHandler() {
			const checkData = () => {
				let differentData = false;
				const originalForm =
					this.drawerBehavior.indexOf('role') !== -1
						? this.roles.find(el => el.id === this.form.id)
						: this.departments.find(el => el.id === this.form.id);
				['id', 'name', 'description'].forEach(key => originalForm[key] !== this.form[key] && (differentData = true));
				if (!differentData) return this.$refs.departmentDrawer.closeDrawer();
			};

			if (this.drawerBehavior.indexOf('edit') !== -1) checkData();

			const valid = await this.validateForm();
			if (!valid) return;

			switch (this.drawerBehavior) {
				case 'new-department':
					return this.onNewDepartment();
					break;
				case 'edit-department':
					return this.onEditDepartment();
					break;
				case 'new-role':
					return this.onAddRole();
					break;
				case 'edit-role':
					return this.onEditRole();
					break;
			}
		},
		handleSelectDeparment(val) {
			this.selectedDepartment = val;
		},
		clearForm(): object {
			return {
				name: '',
				description: '',
			};
		},
		newDepartment(): void {
			this.drawerBehavior = 'new-department';
			this.departmentDrawer = true;
			this.form = { name: '', description: '' };
		},
		newRole(): void {
			this.drawerBehavior = 'new-role';
			this.departmentDrawer = true;
			this.form = { name: '', description: '' };
		},
		editDepartment(row: any, column: any, index: number): void {
			this.drawerBehavior = 'edit-department';
			this.departmentDrawer = true;

			this.form = {
				id: row.id,
				name: row.name,
				description: row.description,
			};
		},
		editRole(row: any): void {
			this.drawerBehavior = 'edit-role';
			this.departmentDrawer = true;

			this.form = {
				id: row.id,
				name: row.name,
				description: row.description,
			};
		},
		async onNewDepartment(): Promise<void> {
			this.loading = true;

			const data = {
				name: this.form.name,
				description: this.form.description,
				roles: this.form.roles,
				path: this.organizationPath,
				workspaceVersion: '2.0.0',
			};

			try {
				await this.$firebase.functions().httpsCallable('addNewDepartment')(data);
				this.loading = false;

				this.$refs.departmentDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('teams.groupCreated'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async onAddRole() {
			this.loading = true;

			const data = {
				name: this.form.name,
				description: this.form.description,
				department: this.selectedDepartment.id,
				path: this.organizationPath,
				workspaceVersion: '2.0.0',
			};

			try {
				const response = await this.$firebase.functions().httpsCallable('addNewRole')(data);
				this.loading = false;

				this.$refs.departmentDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('teams.workspaceAdded', { name: this.selectedDepartment.name }),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		viewRolesWorkspace(row) {
			this.currentSelection = row;
			this.rolesDrawer = true;
		},
		handleTagClose(tag) {
			this.$confirm(this.$t('teams.deleteWorkspaceSimple'), this.$t('common.warning'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning',
			})
				.then(() => {
					this.form.roles.splice(this.form.roles.indexOf(tag), 1);
				})
				.catch();
		},
		handleRoleDialogClose(done) {
			this.roleDialog = false;
			this.roleForm.resetFields();
			done();
		},
		deleteDepartment(row) {
			const users = this.users.filter(el => el.area === row.id);

			if (users.length !== 0)
				return this.$message({
					type: 'error',
					message: this.$t('teams.usersInGroup'),
					duration: 5000,
				});
			const h = this.$createElement;
			this.$msgbox({
				title: this.$t('teams.deleteGroup'),
				message: h('p', null, [h('span', null, this.$t('teams.deleteGroupConfirm', { name: row.name }))]),
				showCancelButton: true,
				confirmButtonText: this.$t('common.delete'),
				cancelButtonText: this.$t('common.cancel'),
				beforeClose: async (action, instance, done) => {
					if (action !== 'confirm') return done();
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = this.$t('common.deleting');
					try {
						const data = {
							id: row.id,
							path: this.organizationPath,
						};
						const response = await this.$firebase.functions().httpsCallable('deleteDepartment')(data);
						this.loading = false;
						this.$message({
							type: 'success',
							message: this.$t('teams.groupDeleted'),
						});
					} catch (error) {
						this.loading = false;

						this.$message({
							type: 'error',
							message: this.$translateError(error),
						});
					}
					done();
					instance.confirmButtonLoading = false;
				},
			});
		},
		deleteRole(row) {
			const users = this.users.filter(el => el.role === row.id);

			if (users.length !== 0)
				return this.$message({
					type: 'error',
					message: this.$t('teams.usersWithWorkspace'),
					duration: 5000,
				});

			const h = this.$createElement;
			this.$msgbox({
				title: this.$t('teams.deleteWorkspace'),
				message: h('p', null, [h('span', null, this.$t('teams.deleteWorkspaceConfirm', { name: row.name }))]),
				showCancelButton: true,
				confirmButtonText: this.$t('common.delete'),
				cancelButtonText: this.$t('common.cancel'),
				beforeClose: async (action, instance, done) => {
					if (action !== 'confirm') return done();
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = this.$t('common.deleting');
					try {
						const data = {
							id: row.id,
							department: this.selectedDepartment.id,
							path: this.organizationPath,
						};
						const response = await this.$firebase.functions().httpsCallable('deleteRole')(data);
						console.log(response);
						this.loading = false;
						this.$message({
							type: 'success',
							message: this.$t('teams.workspaceDeleted'),
						});
					} catch (error) {
						this.loading = false;

						this.$message({
							type: 'error',
							message: this.$translateError(error),
						});
					}
					done();
					instance.confirmButtonLoading = false;
				},
			});
		},
		getInitialFormData(): object {
			return {
				id: '',
				name: '',
				description: '',
			};
		},
		onCloseRolesDrawer(): void {
			this.rolesDrawer = false;
			this.rolesDrawerData = [];
		},
		onCloseDrawer(): void {
			this.departmentDrawer = false;
			this.form = this.getInitialFormData();
			this.$refs.departmentForm.resetFields();
		},
		async onEditDepartment(): Promise<void> {
			this.loading = true;

			const data = {
				id: this.form.id,
				name: this.form.name,
				description: this.form.description,
				path: this.organizationPath,
			};

			try {
				const response = await this.$firebase.functions().httpsCallable('editDepartment')(data);
				this.loading = false;
				this.$refs.departmentDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('teams.groupEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
		async onEditRole(): Promise<void> {
			this.loading = true;

			const data = {
				id: this.form.id,
				name: this.form.name,
				description: this.form.description,
				department: this.selectedDepartment.id,
				path: this.organizationPath,
			};

			try {
				const response = await this.$firebase.functions().httpsCallable('editRole')(data);
				this.loading = false;
				console.log(response);
				this.$refs.departmentDrawer.closeDrawer();

				this.$message({
					type: 'success',
					message: this.$t('teams.workspaceEdited'),
				});
			} catch (error) {
				this.loading = false;
				console.log(error);

				this.$message({
					type: 'error',
					message: this.$translateError(error),
				});
			}
		},
	},
};
